export const RETRIEVE_DOMAIN_DETAILS = "RETRIEVE_DOMAIN_DETAILS";
export const SET_DROPDOWN_VALUE = "SET_DROPDOWN_VALUE";
export const SELECT_DISCOUNT_PROGRAM = "SELECT_DISCOUNT_PROGRAM";
export const SELECT_All_DISCOUNT_PROGRAM = "SELECT_All_DISCOUNT_PROGRAM";
export const UNSELECT_All_DISCOUNT_PROGRAM = "UNSELECT_All_DISCOUNT_PROGRAM";
export const SET_TEXT_VALUE = "SET_TEXT_VALUE";
export const SET_BIDS_TEXT_VALUE = "SET_BIDS_TEXT_VALUE";
export const SET_TRANSACTION_BID_DROPDOWN_VALUE =
  "SET_TRANSACTION_BID_DROPDOWN_VALUE";
export const SET_TRANSACTION_PAYMENT_DROPDOWN_VALUE =
  "SET_TRANSACTION_PAYMENT_DROPDOWN_VALUE";
export const SET_TRANSACTION_REQUEST_DROPDOWN_VALUE =
  "SET_TRANSACTION_REQUEST_DROPDOWN_VALUE";
export const LOAD_BUSINESS_ACTIVITIES = "LOAD_BUSINESS_ACTIVITIES";
export const START_LOADING_APPLICATION = "START_LOADING_APPLICATION ";
export const FINISH_LOADING_APPLICATION = "FINISH_LOADING_APPLICATION";
export const RLTD_ACC_AVL = "RLTD_ACC_AVL";
export const RLTD_ACC_NOT_AVL = "RLTD_ACC_NOT_AVL";
export const DATA_AVAILABLE = "DATA_AVAILABLE";
export const RESET_LOADING_APPLICATION = "RESET_LOADING_APPLICATION";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const SET_SALESPERSON_ID = "SET_SALESPERSON_ID";
export const SET_SALESPERSON_NAME = "SET_SALESPERSON_NAME";
export const CLEAR_SALESPERSON = "CLEAR_SALESPERSON";
export const GET_DEALER_ACCOUNT_DETAILS = "GET_DEALER_ACCOUNT_DETAILS";
export const LOAD_MACHINES_FROM_CACHE = "LOAD_MACHINES_FROM_CACHE";
export const SET_BIDS_PAYMENT_TYPE_TEXT_VALUE =
  "SET_BIDS_PAYMENT_TYPE_TEXT_VALUE";
export const SET_PAYMENT_METHOD = "SET_PAYMENT_METHOD";
export const RESET_CREATE_TRANSACTION_DETAILS_AND_RES_OBJ =
  "RESET_CREATE_TRANSACTION_DETAILS_AND_RES_OBJ";
export const SET_SELECTED_ACCORDION = "SET_SELECTED_ACCORDION";
export const SET_ON_SUBMIT_DETAILS = "SET_ON_SUBMIT_DETAILS";
export const SET_CREATE_TRANSACTION_RESPONSE_OBJ =
  "SET_CREATE_TRANSACTION_RESPONSE_OBJ";
export const CLEAR_CREATE_TRANSACTION = "CLEAR_CREATE_TRANSACTION";
export const SET_SIMULATE_MODE = "SET_SIMULATE_MODE";
export const SET_SIMULATED_BUSINESS_ACTIVITIES =
  "SET_SIMULATED_BUSINESS_ACTIVITIES";
export const RESET_SIMULATED_BUSINESS_ACTIVITIES =
  "RESET_SIMULATED_BUSINESS_ACTIVITIES";
export const SET_SIMULATED_USER_DETAILS = "SET_SIMULATED_USER_DETAILS";
export const RESET_SIMULATED_USER_DETAILS = "RESET_SIMULATED_USER_DETAILS";
export const SET_SEARCH_TRANSACTION_RESPONSE =
  "SET_SEARCH_TRANSACTION_RESPONSE";
export const SET_DEALER_ACCOUNT_DETAILS = "SET_DEALER_ACCOUNT_DETAILS";
export const SET_PARENT_DEALER_ACCOUNT_ID = "SET_PARENT_DEALER_ACCOUNT_ID";
export const SET_STORED_DEALER_ACCOUNT_ID = "SET_STORED_DEALER_ACCOUNT_ID";
export const RESET_STORED_DEALER_ACCOUNT_IDS =
  "RESET_STORED_DEALER_ACCOUNT_IDS";
export const SET_STORED_SALESPERSON_NAMES = "SETCH_STORED_SALESPERSON_NAMES";
export const RESET_STORED_SALESPERSON_NAMES = "RESET_STORED_SALESPERSON_NAMES";
export const SET_STORED_PARENT_DEALER_ACCOUNT_ID =
  "SET_STORED_PARENT_DEALER_ACCOUNT_ID";
export const RESET_STORED_PARENT_DEALER_ACCOUNT_IDS =
  "RESET_STORED_PARENT_DEALER_ACCOUNT_IDS";
export const RESET_SEARCH_TXN_ACCOUNT_DROPDOWNS =
  "RESET_SEARCH_TXN_ACCOUNT_DROPDOWNS";
export const DEALER_DATA_AVAILABLE = "DEALER_DATA_AVAILABLE";
export const SET_SEARCH_TRANSACTION_RESP = "SET_SEARCH_TRANSACTION_RESP";
export const SET_ACTION_TYPE_VALUE = "SET_ACTION_TYPE_VALUE";
export const SET_VIEW_TRANSACTION = "SET_VIEW_TRANSACTION";
export const SET_VIEW_TRANSACTION_BIDS = "SET_VIEW_TRANSACTION_BIDS";
export const SET_SEARCH_OBJ = "SET_SEARCH_OBJ";
export const RESET_SEARCH_OBJ = "RESET_SEARCH_OBJ";
export const SET_TRANSACTION_COUNT = "SET_TRANSACTION_COUNT";
export const LOAD_TRANSLATED_TEXTS = "LOAD_TRANSLATED_TEXTS";
export const SET_SELECTED_TXNS = "SET_SELECTED_TXNS";
export const SET_TABLE_VISIBILITY = "SET_TABLE_VISIBILITY";
export const SET_SELECTED_TXN_STATUS = "SET_SELECTED_TXN_STATUS";
export const RESET_SEARCH_PAGE_COMPONENTS = "RESET_SEARCH_PAGE_COMPONENTS";
export const RESET_SELECTED_TXNS = "RESET_SELECTED_TXNS";
export const RESET_TRANSLATED_TEXTS = "RESET_TRANSLATED_TEXTS";
export const UPLOAD_ATTACHMENTS = "UPLOAD_ATTACHMENTS";
export const REMOVE_ATTACHMENT = "REMOVE_ATTACHMENT"
export const CLEAR_ALL_ATTACHMENTS = "CLEAR_ALL_ATTACHMENTS";
export const TRANSACTION_ATTACHMENT_RESPONSE = "TRANSACTION_ATTACHMENT_RESPONSE";
export const CLEAR_TRANSACTION_ATTACHMENT_RESPONSE="CLEAR_TRANSACTION_ATTACHMENT_RESPONSE";
export const CREATE_TRANSACTION_STATUS = "CREATE_TRANSACTION_STATUS";
